t = require('views/internal/teacup-with-helpers')('members_voted')
memberTemplate = require './member'

module.exports = ->
  t.mustacheBlock 'loading', ->
    t.p '.quiet.u-text-align-center', { style: 'margin: 24px 0;' }, ->
      t.format 'loading-ellipsis'

  t.mustacheBlockInverted 'loading', ->

    t.div { class: 'list-voters u-clearfix ' + t.mustacheBlock('fewMembers', (-> 'compact')) }, ->
      t.mustacheBlock 'members', ->
        t.div '.voter', ->

          t.div '.member.member-no-menu', ->
            memberTemplate t.mustacheVar('.')

          t.mustacheBlock 'fewMembers', ->
            t.p '.title', ->
              t.text t.mustacheVar('fullName')
              t.text ' '
              t.span '.quiet', ->
                t.format 'username', { username: t.mustacheVar('username') }

    t.mustacheBlock 'moreMembers', ->
      t.a '.show-more.mod-compact.js-more-members-voted', { href: '#' }, ->
        t.format 'show-all-voters-lengthdiff-more', { lengthDiff: t.mustacheVar('lengthDiff') }

    t.mustacheBlock 'canVote', ->
      t.hr()

      t.mustacheBlock 'voted', ->
        t.a '.quiet-button.u-text-align-center.js-unvote', { href: '#' }, ->
          t.format 'remove-your-vote'

      t.mustacheBlockInverted 'voted', ->
        t.button '.button.primary.full.js-vote', { href: '#' }, ->
          t.format 'vote'




// WEBPACK FOOTER //
// ./app/scripts/views/templates/members_voted.coffee